import { formatDistanceToNow } from "date-fns";

export function diffForHumans(date: Date): string {
    if (date.getTime() < new Date().getTime()) {
        return formatDistanceToNow(date) + ' ago';
    }

    return 'In ' + formatDistanceToNow(date);
}